import { getServiceEndpoint } from '../utils/endpointUtil';
import type { DescribeArtifactOutput, UpdateArtifactInput, UpdateArtifactOutput } from '@amzn/aws-gcr-content-flywheel-client';

export const artifactService = {
  async fetchArtifact(artifactId: string): Promise<DescribeArtifactOutput> {
    const endpoint = getServiceEndpoint();
    const response = await fetch(`${endpoint}/artifacts/${artifactId}`);

    if (!response.ok) {
      throw new Error(`Failed to fetch artifact: ${response.status}`);
    }

    return response.json();
  },

  async fetchHTMLContent(s3Path: string): Promise<string> {
    const response = await fetch(s3Path);

    if (!response.ok) {
      throw new Error(`Failed to fetch HTML from S3: ${response.status}`);
    }

    return response.text();
  },

  async saveArtifact(artifactId: string, content: string, artifactName: string, latestVersion: number): Promise<UpdateArtifactOutput> {
    const endpoint = getServiceEndpoint();

    const updateInput: UpdateArtifactInput = {
      artifactId,
      content,
      artifactName,
      latestVersion,
    };

    const response = await fetch(`${endpoint}/artifacts/${artifactId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updateInput),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to save artifact: ${response.status} - ${errorText}`);
    }

    return response.json();
  },
};
